const LoaderSimChartData = ({
    daysLenght
}) => {
    return (
        <div className="geo_overview_res_cont_chart_loader">
            <div className="geo_overview_res_cont_chart_loader_row">
                <div className="axis_item_loader fade-in"></div>
            </div>
            <div className="geo_overview_res_cont_chart_loader_row">
                <div className="axis_item_loader fade-in"></div>
            </div>
            <div className="geo_overview_res_cont_chart_loader_row">
                <div className="axis_item_loader fade-in"></div>
            </div>
            <div className="geo_overview_res_cont_chart_loader_row">
                <div className="axis_item_loader fade-in"></div>
            </div>
            <div className="geo_overview_res_cont_chart_loader_row">
                {daysLenght > 0 ? (
                    Array.from({ length: daysLenght }, (_, index) => (
                        <div
                            key={index}
                            className="axis_item_loader_end fade-in"
                        />
                    ))
                ) : (
                    <>
                        <div className="axis_item_loader_end fade-in" />
                        <div className="axis_item_loader_end fade-in" />
                        <div className="axis_item_loader_end fade-in" />
                    </>
                )}
            </div>
        </div>
    )
}

export default LoaderSimChartData